import { getAppData } from '../../lib/api/common';
import {
	getCompanies,
	getCompanyBySlug,
	getCompanySiteData,
	getFeaturedOfferings
} from '../../lib/api/company'

import { getLatestNewsBlockItems } from '../../lib/api/news'
import { getFeaturedDealsBlockItems } from '../../lib/api/deals'

import Layout from '../../components/layout/Layout'
import SeoMaticHead from '../../components/common/SeoMaticHead'
import PageBuilder from '../../components/content/PageBuilder'
import LockUpHero from '../../components/hero/LockUpHero'
import FeaturedOffering from '../../components/content/FeaturedOffering'
import { revalidateSeconds } from "../../lib/helpers/revalidateSeconds";


export type CompanyProps = {
	company: any
	companySiteData: any
	app: any
	dynamicData: any
}


export async function getStaticPaths() {

	const data: any = await getCompanies();
	const paths = data.entries && data.entries.length > 0 ? data.entries.map((entry: any) => {
		return {
			params: {
				siteHandle: entry.slug,
			},
		}
	}) : []

	return {
		paths,
		fallback: 'blocking',
	};
}


export async function getStaticProps(context: any) {

	const slug: Array<string> = context.params && context.params.siteHandle
	const data: any = await getCompanyBySlug(
		slug,
		context.preview ? context.previewData?.token : undefined
	);

	if (!data.company) {
		return {
			notFound: true,
			revalidate: revalidateSeconds()
		}
	}

	// Fetches global navigation and footer data
	const app: any = await getAppData();

	// Fetches company specific navigation
	const companySiteData: any = await getCompanySiteData(slug);

	// Check for dynamic content blocks
	const latestNewsBlocks = data.company.pageBuilder.filter((block: any) => block.typeHandle === 'latestNews')
	const featuredDealsBlocks = data.company.pageBuilder.filter((block: any) => block.typeHandle === 'featuredDeals')

	// Get latest news if block is present
	const latestNews = latestNewsBlocks && latestNewsBlocks.length > 0 ? await getLatestNewsBlockItems( slug ) : null

	// Get latest featured deals if block is present and no deals are selected
	const getLatestDeals = featuredDealsBlocks?.length > 0
	const featuredDeals = getLatestDeals ? await getFeaturedDealsBlockItems() : null

	// Add solutions for events, offerings and other dynamic types

	// Get featured offering from home page on Arctic Securities company page
	const featuredOfferings = data.company.slug == 'securities' ? await getFeaturedOfferings() : null

	return {
		props: {
			app: app,
			company: data.company,
			companySiteData: companySiteData,
			dynamicData: {
				news: latestNews?.news ? latestNews.news : null,
				featuredDeals: featuredDeals?.deals ? featuredDeals.deals : null,
				featuredOfferings: featuredOfferings?.featuredOfferings ? featuredOfferings.featuredOfferings : null
			}
		},
		revalidate: revalidateSeconds()
	}
}

export default function Company(props: CompanyProps) {

	const { company, companySiteData, app, dynamicData } = props

	// console.log('Company page props: ', props)

	return (
		<>
			<SeoMaticHead seo={company.seo} />
			<Layout
				appData={app}
				key={company.uri}
				companySiteData={companySiteData}
			>
				<>
					<LockUpHero
						block={company.pageHeader && company.pageHeader.length > 0 ? company.pageHeader[0] : null}
						fallBackTitle={company.title}
					/>
					{dynamicData.featuredOfferings &&
						<FeaturedOffering offering={dynamicData.featuredOfferings.featuredOffering} heading={dynamicData.featuredOfferings.heading} />
					}
					<PageBuilder
						contentBlocks={company.pageBuilder}
						dynamicData={dynamicData}
					/>
				</>
			</Layout>
		</>
	)
}

